import { Component, Input } from '@angular/core';
import { BuildingBlockElementsBaseComponent } from '../shared/building-block-elements-base.component';

@Component({
  selector: 'cu-dynamic-field',
  templateUrl: './dynamic-field.component.html',
  standalone: false
})
export class DynamicFieldComponent extends BuildingBlockElementsBaseComponent {
  /** Field index in card fields array. */
  @Input() public fieldIndex: number;
}
